import axios from 'axios'

import { OrderByEnum } from '../gql/graphql'
import {
  markAllNotificationsAsReadMutation,
  markNotificationAsReadMutation,
  notificationsQuery,
} from '../queries/graphql/graphqlQueries'
import { useAppStore } from '../store/appStore/appStore'
import { apolloClient } from './apolloClient'

export const fetchNotifications = async (pageNumber = 1) => {
  const result = await apolloClient.query({
    query: notificationsQuery,
    variables: {
      first: 100,
      skip: Math.max(pageNumber - 1, 0) * 100,
      orderBy: [{ createdDate: OrderByEnum.Desc }],
    },
  })

  return ((result.data as any)?.Notification_list?.items ?? []) as any[]
}

export const downloadFile = async ({ fileId }: { fileId: string }) => {
  try {
    const response = (
      await axios.get<any>(
        `${useAppStore.getState().config.API_URL}/notification/${useAppStore.getState().auth.user!.organization!.name}/download/${fileId}`,
        { responseType: 'blob' },
      )
    ).data
    return response
  } catch (e: unknown) {
    console.error('Error downloading file', e)
    throw e
  }
}

export const markAllNotificationsAsRead = async () => {
  const result = await apolloClient.mutate({
    mutation: markAllNotificationsAsReadMutation,
  })
  return (result.data as any)?.markAllNotificationsAsRead
}

export const markNotificationAsRead = async (notificationId: string) => {
  const result = await apolloClient.mutate({
    mutation: markNotificationAsReadMutation,
    variables: { notificationId },
  })
  return (result.data as any)?.markNotificationAsRead
}

export const createDownloadDocument = async (
  fileId: string,
  fileName: string,
): Promise<Blob> => {
  const blob = await downloadFile({ fileId })
  if (!blob) {
    throw new Error('Failed to download file')
  }
  const dataUrl = window.URL.createObjectURL(blob)
  const elm = document.createElement('a')
  elm.setAttribute('href', dataUrl)
  elm.setAttribute('download', `${fileName}.csv`)
  elm.style.display = 'none'
  document.body.appendChild(elm)
  elm.click()
  document.body.removeChild(elm)
  return blob
}
